import script from "./ProductName.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductName.vue?vue&type=script&setup=true&lang=js"

import "./ProductName.vue?vue&type=style&index=0&id=59042e2d&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59042e2d"]])

export default __exports__